// Pure plate-ordering logic for the registerCar fleet, kept CommonJS and free of
// firebase so scripts/check-fleet.js can require it. src/components/fleet.js
// does the Firestore read and delegates the ordering here.

// A collection get() returns documents in id order, which is not the order the
// legacy carSmall / carLarge arrays were written in. Three places render plates
// in that array order (the carBooking row grid, the carSchedule regNum dropdown,
// and its GetScheCar list), so sort by the explicit `order` field to keep the
// display identical. Documents without one sort last rather than jumping to the
// front, and regNum breaks ties.
const LAST = Number.MAX_SAFE_INTEGER

function orderOf (vehicle) {
  return typeof vehicle.order === 'number' ? vehicle.order : LAST
}

// vehicles: [{ regNum, size, order }] -> plate strings for one size, in order.
function selectPlates (vehicles, size) {
  return vehicles
    .filter(v => v && v.size === size)
    .sort((a, b) => orderOf(a) - orderOf(b) || String(a.regNum).localeCompare(String(b.regNum)))
    .map(v => v.regNum)
}

module.exports = { selectPlates }
